import type { OrderModel } from '@/types/models/OrderModel'

export type OrderState = {
    orders: OrderModel[]
    order?: OrderModel
}

export enum EOrderActions {
    FETCH_ORDERS = 'fetchOrders',
    FETCH_ORDER = 'fetchOrder',
    CREATE_ORDER = 'createOrder',
    UPDATE_ORDER = 'updateOrder',
    DELETE_ORDER = 'deleteOrder',
    RESET_ORDER = 'resetOrder'
}

export enum EOrderMutations {
    SET_ORDERS = 'setOrders',
    SET_ORDER = 'setOrder',
    SET_LOADING = 'setLoading',
    SET_PAGINATION = 'setPagination',
    REMOVE_ORDER = 'removeOrder',
    RESET_ORDER = 'resetOrder'
}
